import { reactive } from 'vue';

/**
 * PWA glue: registers the service worker, tracks install availability, and
 * exposes an install() the UI can call from an "Install app" button.
 */
export const pwa = reactive({
  canInstall: false,   // browser fired beforeinstallprompt and app isn't installed
  installed: false,
  updateReady: false,  // a new version was fetched and is waiting
});

let deferredPrompt = null;
let waitingWorker = null;

export function initPwa() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').then((reg) => {
        // Detect an updated service worker waiting to activate.
        reg.addEventListener('updatefound', () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener('statechange', () => {
            if (nw.state === 'installed' && navigator.serviceWorker.controller) {
              waitingWorker = nw;
              pwa.updateReady = true;
            }
          });
        });
      }).catch(() => { /* SW registration failed — app still works online */ });
    });
  }

  // Already running as an installed app?
  if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
    pwa.installed = true;
  }

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    pwa.canInstall = true;
  });

  window.addEventListener('appinstalled', () => {
    pwa.canInstall = false;
    pwa.installed = true;
    deferredPrompt = null;
  });
}

export async function promptInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  pwa.canInstall = false;
  return choice && choice.outcome === 'accepted';
}

export function applyUpdate() {
  if (waitingWorker) waitingWorker.postMessage('SKIP_WAITING');
  pwa.updateReady = false;
  window.location.reload();
}
